import { environment } from '../environments/environment';

// En producción, Angular maneja el baseHref, así que mantenemos esta ruta vacía
// En modo desarrollo, podemos necesitar la ruta para pruebas
export const BASE = environment.production ? 'seguros/movilidad/motos/cotizador' : '';

function buildPath(path: string): string {
  return BASE ? `${BASE}/${path}` : path;
}

export const SIN_ZONA = buildPath('sin_zona');
export const TIEMPO_INACTIVO = buildPath('tiempo_inactivo');
export const COTIZACION_PAUSA_INACTIVO = buildPath('cotizacion-pausa-inactivo');
export const CREAR_LEAD = buildPath('crear_lead');
export const POLIZA_ACTIVA = buildPath('poliza_activa');
export const COTIZACION_PAUSA = buildPath('cotizacion_pausa');
export const NO_PREPARADOS = buildPath('no_preparados');
export const RESUMEN_COMPRA = buildPath('resumen_compra');
export const LOADER = buildPath('loader');
export const LOADER_MOTO = buildPath('loader_moto');
export const NO_ES_SOAT = buildPath('no_es_soat');
export const FEEDBACK = buildPath('feedback');
export const YATEMENOSDATOS = buildPath('ya_tenemos_datos');
export const CONSULTA_RUNT = buildPath('consulta_runt');
export const LEAD_ERRADO = buildPath('lead_errado');
export const PLANES = buildPath('planes');
export const DATOS_RESTANTES = buildPath('datos_restantes');
export const PAGO_APROBADO = buildPath('pago_aprobado');
export const PAGO_APROBADO_NO_AP = buildPath('pago_aprobado_no_ap');
export const PROCESANDO_PAGO = buildPath('procesando_pago');
export const PAGO_RECHAZADO = buildPath('pago_rechazado');
export const FINAL_PAGE = buildPath('final_page');
export const FACTURAS_PENDIENTES = buildPath('facturas_pendientes');

export const DEFAULT = `${BASE}`;
export const REDIRECT = 'seguros/movilidad/motos/cotizador';
// En producción, Angular ya tiene el baseHref, así que solo necesitamos 'cotizador'
// En desarrollo, necesitamos la ruta completa

// Ruta utilizada para redirección cuando se detecta DevTools
// Podemos usar una ruta existente para este propósito
export const NO_SOAT = buildPath('no_devtolls');

/**URL Onerosos */

export const ONEROSO = buildPath('oneroso');

/**URL Retoma Duplicado */

export const RETOMA_DUPLICADO = buildPath('retoma_duplicado');
